import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import AreaOfStudyService from "../../../Services/AreaOfStudy.service";
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
const ACTIVE_DEFAULT = 1;
// @ts-expect-error - TS7034 - Variable 'AREA_OF_STUDY_TYPE_ID_DEFAULT' implicitly has type 'any[]' in some locations where its type cannot be determined.
const AREA_OF_STUDY_TYPE_ID_DEFAULT = [];
const DEFAULT_SEARCH = {
    query: SEARCH_DEFAULT,
    active: ACTIVE_DEFAULT,
    // @ts-expect-error - TS7005 - Variable 'AREA_OF_STUDY_TYPE_ID_DEFAULT' implicitly has an 'any[]' type.
    areaOfStudyTypeIds: AREA_OF_STUDY_TYPE_ID_DEFAULT,
};
const AreaOfStudyLookup = ({ selected: selectedAreasOfStudy, children, areaOfStudyTypeId: defaultAreaOfStudyTypeId, }) => {
    var _a;
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(Object.assign(Object.assign({}, DEFAULT_SEARCH), { areaOfStudyTypeIds: [defaultAreaOfStudyTypeId] }));
    const [active, setActive] = React.useState(ACTIVE_DEFAULT);
    const [validationError, setValidationError] = React.useState(null);
    const searchItems = () => {
        setValidationError(null);
        setSearchArgs({
            query,
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type '0 | 1 | 2'.
            active,
            areaOfStudyTypeIds: [defaultAreaOfStudyTypeId],
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedAreasOfStudy || [],
        // eslint-disable-next-line eqeqeq
        equalsFunc: (a, b) => a.id == b.id,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getData: (sort, page, sArgs) => {
            let isActive;
            switch (sArgs.active) {
                case 0:
                    isActive = false;
                    break;
                case 1:
                    isActive = true;
                    break;
                case 2:
                default:
                    isActive = null;
            }
            return AreaOfStudyService.search({
                areaOfStudyTypeIds: sArgs.areaOfStudyTypeIds,
                query: sArgs.query,
                active: isActive,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
            });
        },
        searchArgs,
        getNumPages: (result) => 
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No results found",
        // @ts-expect-error - TS2322 - Type '{ sortId: string; order: "asc"; }' is not assignable to type 'Sort'.
        initialSort: { sortId: "AREANAME", order: "asc" },
        columns: [
            {
                title: "Code",
                sortId: "AREACODE",
            },
            {
                title: "Name",
                sortId: "AREANAME",
            },
            {
                title: "Active",
                sortId: "AREAACTIVE",
            },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => {
            // @ts-expect-error - TS7006 - Parameter 'areaOfStudy' implicitly has an 'any' type.
            return data.map((areaOfStudy) => [
                areaOfStudy.code,
                areaOfStudy.name,
                _jsx(BooleanDisplay, { val: areaOfStudy.active }, "active"),
            ]);
        },
    });
    return children({
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        lookup: (_jsxs(_Fragment, { children: [validationError && _jsx(AlertError, { message: validationError }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "nameSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "nameSearch", placeholder: "Search Name, Code", style: { width: 200 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsxs("div", { className: "form-group mr-3 mt-2", children: [_jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeTrue", value: "1", checked: active === 1, onChange: () => {
                                                setActive(1);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeTrue", children: "Active" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input ", type: "radio", id: "activeFalse", checked: active === 0, onChange: () => {
                                                setActive(0);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeFalse", children: "Inactive" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeBoth", checked: active === 2, onChange: () => {
                                                setActive(2);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeBoth", children: "Both" })] })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
    });
};
const makeAreaOfStudyLookup = (areaOfStudyTypeId) => (props) => (_jsx(AreaOfStudyLookup, Object.assign({}, props, { areaOfStudyTypeId: areaOfStudyTypeId })));
export default makeAreaOfStudyLookup;
